module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-about"
  }, [_c('top-subpage-section', [_c('page-header', {
    attrs: {
      "title": "About"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content-bg"
  }, [_c('about-sub-section', {
    attrs: {
      "id": "about-partner-1",
      "name": "bosshog::about-partner-1"
    }
  }), _vm._v(" "), _c('about-sub-section', {
    attrs: {
      "id": "about-partner-3",
      "name": "bosshog::about-partner-3"
    }
  })], 1), _vm._v(" "), (false) ? _c('vm-back-top', {
    attrs: {
      "bottom": 45,
      "right": 25,
      "duration": 1000,
      "timing": 'ease'
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('span')])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ce1d66c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 928
// module chunks = 1